
import FulfillmentOptionComponent from './FulfillmentOption.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { useBreakpoints } from 'JS/composables/breakpoint';

@Component({
	name: 'StandardShipping',
	components: {
		FulfillmentOptionComponent
	}
})
export default class StandardShipping extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/
	@Get('product')
	readonly product: any;

	@Get('shippingMessage')
	readonly shippingMessage: string;

	@Get('shippingMessageMobile')
	readonly shippingMessageMobile: string;

	@Get('isShippingPromoRewardsOnly')
	readonly isShippingPromoRewardsOnly: boolean;

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('shippingError')
	readonly shippingError: string;

	@Get('shippingDeliveryDateNew')
	readonly shippingDeliveryDateNew: string;

	@Get('selectedFulfillmentType')
	readonly selectedFulfillmentType: FulfillmentType;

	@Get('isInStockForShip')
	readonly isInStockForShip: boolean;

	@Get('isShippingDisabled')
	readonly isShippingDisabled: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;
	
	@Get('inStoreOnly')
	readonly inStoreOnly: boolean;


	get isMobile(): boolean {
		return useBreakpoints().isMobile.value;
	} 

	get isTablet(): boolean {
		return useBreakpoints().isTablet.value;
	} 

	get isDisabled(): boolean {
		return this.isShippingDisabled
				|| !this.hasSelectedVariant
				|| this.fetchingProduct
				|| this.loading;
	};

	get estimatedDelivery() {
		return this.shippingDeliveryDateNew
			? `Arrives ${this.shippingDeliveryDateNew}` : null;
	};

	get isSelected(): boolean {
		return this.fulfillmentOption === this.selectedFulfillmentType;
	};

	get shippingPromo(): string {
		if (this.isInStockForShip) {
			if (this.isMobile || this.isTablet) {
				return this.shippingMessageMobile;
			}
			return this.shippingMessage;
		}

		return '';
	}

	get secondaryLabel(): string {
		if (this.inStoreOnly) {
			return "Not available";
		} else if (!this.isInStockForShip) {
			return "Out of Stock";
		} else if (this.isInStockForShip) {
			if (!!this.product.arrivalDate) {
				return null;
			} else if (this.estimatedDelivery) {
				return this.estimatedDelivery;
			}
		}

		return "";
	}

	get showOrderByDisclaimer(): boolean {
		if (this.inStoreOnly || !this.isInStockForShip) {
			return false;
		} else if (this.isInStockForShip && this.estimatedDelivery) {
			return !!this.product.orderByDate;
		} else {
			return false;
		}
	}

	/* Data
	============================================*/
	readonly fulfillmentOption: FulfillmentType = FulfillmentType.StandardShipping;

	/* Lifecycle Hooks
	============================================*/
	mounted() {
		if (!this.shippingDeliveryDateNew) {
			this.$store.dispatch('getShippingInfo');
		}
	}
}
